var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRejection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 12.792C20.6529 14.4599 20.0554 16.0495 19.0774 17.3746C18.0994 18.6997 16.7814 19.7057 15.2776 20.2747C13.7738 20.8438 12.1464 20.9524 10.5859 20.5878C9.0253 20.2233 7.59612 19.4007 6.46554 18.2163C5.33495 17.0319 4.54974 15.5346 4.20177 13.8997C3.8538 12.2649 3.95747 10.56 4.50065 8.98458C5.04383 7.40918 6.00405 6.02842 7.26896 5.00387C8.53387 3.97932 10.0511 3.35336 11.6432 3.19922C10.7111 4.52033 10.2626 6.14805 10.3792 7.78633C10.4958 9.42462 11.1698 10.9646 12.2787 12.1263C13.3876 13.288 14.8576 13.9941 16.4214 14.1163C17.9852 14.2384 19.5389 13.7685 20.8 12.792Z",
    fill: "#28323C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRejection);
export default __webpack_public_path__ + "static/media/ic_rejection.63ae99e98081a9b3921744a9c58e7a0d.svg";
export { ForwardRef as ReactComponent };